import React, { Fragment, useEffect, useRef, useState } from "react";
import { isEmpty } from "lodash";
import { Box, Divider, Drawer, Tab, Typography, styled } from "@mui/material";
import moment from "moment";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Log, sendDataWithPost } from "../../../services/services";
import { useLoadingSpinnerContext } from "../../../context/loadingSpinnerContext";
import Quill from "../wysiwyg-html-editor";

const DRAWER_WIDTH = 550;
const primaryColor = "#106ba3";

const StyledTab = styled(Tab)({
  "&.Mui-selected": {
    color: primaryColor,
  },
});

const ProductUpdateDrawer = ({ open, setOpenDrawer }) => {
  const { setGlobalLoading } = useLoadingSpinnerContext();
  const elRefs = useRef([]);
  const [data, setData] = useState();
  const [value, setValue] = useState("recently");

  const handleChange = (event, newValue) => {
    fetchData(newValue);
  };

  const onCloseDrawer = () => {
    setOpenDrawer(false);
    setData(false);
  };

  const fetchData = async (value) => {
    const currentDate = moment().format("YYYY-MM-DD");
    const sixMonthsAgoDate = moment()
      .subtract(6, "months")
      .format("YYYY-MM-DD");
    const dateRange = {
      start_datetime: value === "recently" ? sixMonthsAgoDate : "",
      end_datetime: value === "recently" ? currentDate : sixMonthsAgoDate,
    };
    const payload = {
      title: "",
      description: "",
      service_scope: "Admin portal",
      status: "published",
      ...dateRange,
    };
    const url = `/admins/product_update/filter/`;
    Log.info(`Show product update ${value === "recently" ? "for" : "over"} 6 months`, payload)
    setGlobalLoading(true);
    await sendDataWithPost(
      url,
      payload,
      setData,
      null,
      () => setValue(value),
      onCloseDrawer
    );
    setGlobalLoading(false);
  };

  useEffect(() => {
    (async () => {
      if (open) {
        fetchData(value);
      }
    })();
  }, [open]);

  const renderList = () => {
    return (
      <Box sx={{ pt: 3 }}>
        {isEmpty(data?.results) ? (
          <Typography
            sx={{ pt: 2 }}
            align="center"
            variant="subtitle2"
            color="#7d7c7d"
          >
            No articles found
          </Typography>
        ) : (
          data?.results?.map((item, index) => (
            <Fragment key={item.id}>
              <Box sx={{ px: 2, pt: 2 }}>
                <Typography
                  variant="body2"
                  display="block"
                  gutterBottom
                  color="#7d7c7d"
                >
                  {moment(item.published_date).format("Do MMM YYYY hh:mm:ss")}
                </Typography>
                <Typography variant="h6" gutterBottom>
                  {item.title}
                </Typography>
                <Quill
                  value={item.description}
                  readOnly
                  toolbar={false}
                  styles={{
                    height: "auto",
                    border: "unset",
                  }}
                />
              </Box>
              {data.results.length - 1 !== index && (
                <Divider sx={{ mt: 2, borderColor: "black" }} />
              )}
            </Fragment>
          ))
        )}
      </Box>
    );
  };

  if (!data) return <></>;
  return (
    <Drawer
      open={open}
      onClose={onCloseDrawer}
      anchor="right"
      PaperProps={{
        sx: { width: DRAWER_WIDTH },
      }}
    >
      <Box>
        <TabContext value={value}>
          <Box
            sx={{
              position: "fixed",
              backgroundColor: "#fff",
              width: "100%",
              borderBottom: 1,
              borderColor: "divider",
              zIndex: 1,
            }}
          >
            <TabList
              onChange={handleChange}
              TabIndicatorProps={{ style: { backgroundColor: primaryColor } }}
            >
              <StyledTab label="Recently" value="recently" />
              <StyledTab label="Archived" value="archived" />
            </TabList>
          </Box>
          <TabPanel value="recently" sx={{ px: 0 }}>
            {renderList()}
          </TabPanel>
          <TabPanel value="archived" sx={{ px: 0 }}>
            {renderList()}
          </TabPanel>
        </TabContext>
      </Box>
    </Drawer>
  );
};

export default ProductUpdateDrawer;
